import { toast } from 'sonner';

export type NotificationOptions = {
  description?: string;
  duration?: number;
};

export const NOTIFICATION_DURATION = {
  success: 3_000,
  info: 3_000,
  warning: 4_000,
  error: 5_000,
} as const;

type NotificationType = keyof typeof NOTIFICATION_DURATION;

function notify(type: NotificationType, message: string, options?: NotificationOptions): void {
  toast[type](message, {
    duration: options?.duration ?? NOTIFICATION_DURATION[type],
    ...(options?.description ? { description: options.description } : {}),
  });
}

export const notifications = {
  success: (message: string, options?: NotificationOptions) => notify('success', message, options),
  info: (message: string, options?: NotificationOptions) => notify('info', message, options),
  warning: (message: string, options?: NotificationOptions) => notify('warning', message, options),
  error: (message: string, options?: NotificationOptions) => notify('error', message, options),
};
